import {
  MAIN_DATE_FORMAT,
  MAIN_TIME_FORMAT,
  NO_VALUE_DISPLAY,
} from "../../constants";
import { TimeZoneEnum } from "../../enums";
import { dateISOApplyTimezone, isMidnight } from "../date.helpers";

export const formatCalendarDateToNormalized = (
  date: TDateISO,
  formatNormalized: string,
  timezone: TimeZoneEnum,
): string => {
  if (!date) {
    return NO_VALUE_DISPLAY;
  }

  const isMidnightDate = isMidnight(date, timezone);

  if (isMidnightDate) {
    return dateISOApplyTimezone(date, timezone)
      .add(-1, "d")
      .format(formatNormalized || MAIN_DATE_FORMAT);
  }

  return dateISOApplyTimezone(date, timezone).format(
    formatNormalized || MAIN_TIME_FORMAT,
  );
};
